import React, { useEffect, CSSProperties } from "react";
import { useState } from "react";
import { createRoot } from "react-dom/client";
import { MoonLoader } from "react-spinners";
import { Slide, toast, ToastContainer } from "react-toastify";

export function PDPScrapper() {
    const nonce = document.getElementById("wp-nonce") as HTMLInputElement;
    this.urlInput = React.createRef();
    this.postIdInput = React.createRef();
    this.submitBtn = React.createRef();
    this.resetBtn = React.createRef();
    this.addBtn = React.createRef();
    this.deleteBtn = React.createRef();
    const [showSpinner, setShowSpinner] = useState(false);
    const [options, setOptions] = useState([]);
    const [inputScreenState, setInputScreenState] = useState(true);
    const [urlValue, setUrlValue] = useState("");
    const [postIdValue, setPostIdValue] = useState("");

    const override: CSSProperties = {
        margin: "0 auto",
    };

    useEffect(() => {
        const getOptionsFunc = (event) => {
            event.preventDefault();
            setShowSpinner(true);
            setInputScreenState(false);
            const params = new URLSearchParams({
                url: this.urlInput.current.value,
            });
            fetch(`/wp-json/geminimade/v2/pdp-get-options?${params}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "X-WP-Nonce": nonce.value,
                },
            })
                .then((response) => response.json())
                .then((data) => {
                    setOptions(data);
                    setShowSpinner(false);
                });
        };
        this.submitBtn.current.addEventListener("click", getOptionsFunc);
        const addOptionsFunc = (event) => {
            event.preventDefault();
            setShowSpinner(true);
            let tempOptions = [];
            for (var i = 0; i < options.length; i++) {
                let hasChecks = false;
                let checkboxes = document.getElementsByClassName("checkbox-" + i);
                for (var ii = 0; ii < options[i].option.length; ii++) {
                    options[i].option[ii].material = [];
                    for (var iii = 0; iii < checkboxes.length; iii++) {
                        if (checkboxes[iii].checked) {
                            options[i].option[ii].material.push(checkboxes[iii].value);
                            hasChecks = true;
                        }
                    }
                }
                if (hasChecks) {
                    tempOptions.push(options[i]);
                }
            }
            fetch("/wp-json/geminimade/v2/pdp-add-options", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-WP-Nonce": nonce.value,
                },
                body: JSON.stringify({ postId: postIdValue, options: tempOptions }),
            })
                .then((response) => response.json())
                .then((data) => {
                    console.log(data);
                    toast.success("Success");
                })
                .catch(() => {
                    toast.error("An error occured");
                })
                .finally(() => {
                    setShowSpinner(false);
                });
        };
        this.addBtn.current.addEventListener("click", addOptionsFunc);
        const clearOptionsFunc = (event) => {
            event.preventDefault();
            setShowSpinner(true);
            fetch("/wp-json/geminimade/v2/pdp-clear-options", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-WP-Nonce": nonce.value,
                },
                body: JSON.stringify({ postId: this.postIdInput.current.value }),
            })
                .then((response) => response.json())
                .then((data) => {
                    toast.success("Success");
                })
                .catch(() => {
                    toast.error("An error occured");
                })
                .finally(() => {
                    setShowSpinner(false);
                });
        };
        this.deleteBtn.current.addEventListener("click", clearOptionsFunc);
        const resetFunc = (event) => {
            event.preventDefault();
            setOptions([]);
            setInputScreenState(true);
        };
        this.resetBtn.current.addEventListener("click", resetFunc);
        return () => {
            this.submitBtn.current.removeEventListener("click", getOptionsFunc);
            this.addBtn.current.removeEventListener("click", addOptionsFunc);
            this.deleteBtn.current.removeEventListener("click", clearOptionsFunc);
            this.resetBtn.current.removeEventListener("click", resetFunc);
        };
    }, [options]);

    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick={false}
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
                transition={Slide}
                style={{ marginTop: "2rem" }}
            />
            {showSpinner && (
                <div className="spinner-backdrop">
                    <MoonLoader
                        cssOverride={override}
                        size={80}
                        color={"#000000"}
                        loading={true}
                        speedMultiplier={1}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                    />
                </div>
            )}
            <div>
                <div style={{ display: "inline-block" }}>
                    <label htmlFor="url">URL</label>
                    <input
                        ref={this.urlInput}
                        id="url"
                        className="form-text-input"
                        disabled={!inputScreenState}
                        style={{ width: "15rem" }}
                        onChange={(e) => setUrlValue(e.target.value)}
                    />
                </div>
                <div style={{ marginLeft: ".5rem", display: "inline-block" }}>
                    <label htmlFor="url" style={{ display: "block" }}>
                        Post ID
                    </label>
                    <input
                        ref={this.postIdInput}
                        id="post-id"
                        className="form-text-input"
                        name="post_id"
                        disabled={!inputScreenState}
                        style={{ display: "inline", maxWidth: "5rem" }}
                        onChange={(e) => setPostIdValue(e.target.value)}
                    />
                    <button
                        ref={this.deleteBtn}
                        style={{ marginLeft: ".5rem" }}
                        disabled={postIdValue ? false : true}
                    >Delete Options</button>
                </div>
                <input id="page" name="page" type="hidden" value="pdp-scrapper" />
            </div>
            <div className="options">
                {options.map((item, index) => (
                    <div className="option-checkboxes">
                        <h3>{item.option_name}</h3>
                        <table>
                            <tr>
                                <td style={{ verticalAlign: 'top' }}>
                                    <table>
                                        <tr>
                                            <td className="option-table-cell">Flat Cut Metal: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="flat-cut-metal"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Face & Halo Lit: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="face-halo-lit"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Acrylic: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="acrylic"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Aluminum: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="aluminum"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Brass: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="brass"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Bronze: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="bronze"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Flat Cut PVC: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="flat-cut-pvc"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Fabricated Metal: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="fabricated-metal"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Formed Plastic: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="formed-plastic"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Injection Molded Plastic: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="injection-molded-plastic"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Laminate: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="laminate"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Fabricated Metal Lit: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="fabricated-metal-lit"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Cast Metal Halo Lit: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="cast-metal-halo-lit"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Niche & Crypt Plaques: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="niche-crypt-plaques"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Custom Fabricated Blanks: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="custom-fabricated-blanks"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">ADM: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="adm"
                                                />
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                                <td style={{ verticalAlign: 'top' }}>
                                    <table>
                                        <tr>
                                            <td className="option-table-cell">Lit Acrylic: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="lit-acrylic"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Copper: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="copper"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Cor-Ten: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="cor-ten"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Steel: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="stainless-steel"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Lit Formed Plastic: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="lit-formed-plastic"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Blade Signs: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="blade-signs"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Precision Plaques: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="precision-plaques"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Cast Plaques: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="cast-plaques"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Etched Plaques: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="etched-plaques"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">ADA & Wayfinding: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="ada-and-wayfinding"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Raised Print: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="raised-print"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Bronze Memorials: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="bronze-memorials"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Thin Gauge Metal: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="thin-guage-metal"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">GemTrim™ Flex Trim Cap: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="gemtrim-flex-trim-cap"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Stock Blanks: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="stock-blanks"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Modern: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="modern"
                                                />
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                                <td style={{ verticalAlign: 'top' }}>
                                    <table>
                                        <tr>
                                            <td className="option-table-cell">Stainless Steel Halo Lit: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="stainless-steel-halo-lit"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Aluminum Halo Lit: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="aluminum-halo-lit"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Trimless Fabricated Stainless Steel Halo Lit: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="trimless-stainless-steel-halo-lit"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Trimless Fabricated Stainless Steel Face Lit: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="trimless-stainless-steel-lit"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Trimless Fabricated Aluminum Halo Lit: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="trimless-aluminum-halo-lit"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Trimless Fabricated Aluminum Face Lit: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="trimless-aluminum-face-lit"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Stainless Steel Face Lit: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="stainless-steel-face-lit"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Aluminum Face Lit: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="aluminum-face-lit"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">GemLeaf: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="gemleaf"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Laminate on Foam: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="laminate-on-foam"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Metal Laminate on Acrylic: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="metal-laminate-on-acrylic"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Standard Bronze Memorials: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="standard-bronze-memorials"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Custom Bronze Memorials: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="custom-bronze-memorials"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Pronto™ Changeable Copy: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="pronto-changeable-copy"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Trimless Channel Aluminum: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="trimless-channel-aluminum"
                                                />
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                                <td style={{ verticalAlign: 'top' }}>
                                    <table>
                                        <tr>
                                            <td className="option-table-cell">Face Lit: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="face-lit"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Face & Side Lit: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="face-side-lit"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Side Lit w/Laminate Face: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="side-lit-laminate-face"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Side Lit w/Painted Face: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="side-lit-painted-face"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Face & Side Lit w/Vinyl Face: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="vinyl-face-side-lit"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Face Lit w/Vinyl: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="face-lit-vinyl"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Face & Halo Lit w/Vinyl: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="face-halo-lit-vinyl"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Trimless Halo Lit: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="trimless-halo-lit"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Face & Side Lit: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="face-side-lit"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Halo Lit: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="halo-lit"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Side Lit: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="side-lit"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Faux Neon: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="faux-neon"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">W-N Art Bronze: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="w-n-art-bronze"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Metal Engraving Supplies: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="metal-engraving-supplies"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Trimless Channel Stainless Steel: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="trimless-channel-stainless-steel"
                                                />
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                                <td style={{ verticalAlign: 'top' }}>
                                    <table>
                                        <tr>
                                            <td className="option-table-cell">Blade Signs - Lit: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="blade-signs-lit"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Blade Signs - Non-Lit: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="blade-signs-non-lit"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Etched Stainless Steel: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="etched-stainless-steel"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Etched Brass: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="etched-brass"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Etched Bronze: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="etched-bronze"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Etched Stainless Steel: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="etched-stainless-steel"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Etched Nickel Silver: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="etched-nickel-silver"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Etched Aluminum: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="etched-aluminum"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Etched Brass: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="etched-brass"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Etched Copper: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="etched-copper"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Anodized Aluminum: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="anodized-aluminum"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Nickel Silver: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="nickel-silver"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">PhotoRelief™ Memorials: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="photorelief-memorials"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Sheet Metal: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="sheet-metal"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="option-table-cell">Condensed: </td>
                                            <td className="option-table-cell">
                                                <input
                                                    className={"checkbox-" + index}
                                                    type="checkbox"
                                                    value="condensed"
                                                />
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                        </table>
                    </div>
                ))}
            </div>
            <div style={{ marginTop: "1rem" }}>
                <button
                    ref={this.submitBtn}
                    style={{ display: inputScreenState ? "inline" : "none" }}
                    disabled={urlValue && postIdValue ? false : true}
                >Submit</button>
                <button
                    ref={this.resetBtn}
                    style={{ display: inputScreenState ? "none" : "inline" }}
                >Reset Form</button>
                <button
                    ref={this.addBtn}
                    disabled={options.length ? false : true}
                >Add Options</button>
            </div>
        </>
    );
}

export function pdpScrapperInit() {
    const root = createRoot(document.getElementById("pdp-scrapper-content")!);
    root.render(<PDPScrapper></PDPScrapper>);
}
